// @flow weak

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Home from "./Home";
import { userActions } from "../../../redux/actions/user";

const mapStateToProps = state => {
  return {
    userResponse: state.user.userResponse,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      ...userActions,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/app/views/admin/home/index.js